import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import Menu from "../components/Menu";
import QualidadeDiario from "../components/Tabelas/QualidadeDiario";

import api from "../services/api";

export default function RelatorioQualidadeDiario() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    
    const [date, setDate] = useState(() => {
        const ontem = new Date();
        ontem.setDate(ontem.getDate() - 1);
        return ontem;
    });

    const [foco, setFoco] = useState("");
    const [loading, setLoading] = useState(true);

    const toast = useRef(null);
    const printRef = useRef(null);

    const buscarRelatorio = (customDate) => {
        setLoading(true);

        const query = customDate
            ? `?data=${customDate.getFullYear()}-${String(customDate.getMonth() + 1).padStart(2, "0")}-${String(
                  customDate.getDate()
              ).padStart(2, "0")}`
            : "";

        api
            .get(`defeitos/relatorio-diario-qualidade${query}`)
            .then((response) => {
                setData(response.data);
                toast.current?.show({
                    summary: "Concluído",
                    severity: "success",
                    detail: "Relatório gerado com sucesso.",
                });
            })
            .catch((error) => {
                toast.current?.show({
                    summary: "Ocorreu um Erro",
                    severity: "error",
                    detail: error.response ? error.response.data.message : error.message,
                });
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        buscarRelatorio(date);
    }, []);

    const nomeArquivo = (ext) => {
        const nomeData = data?.resultado_do_dia?.data?.replaceAll("/", "-") || "diario";
        return `relatorio-qualidade-${nomeData}.${ext}`;
    };

    const handleDownloadImage = () => {
        if (!printRef.current) return;

        html2canvas(printRef.current, { scale: 2, backgroundColor: "#ffffff" })
            .then((canvas) => {
                const link = document.createElement("a");
                link.download = nomeArquivo("png");
                link.href = canvas.toDataURL("image/png");
                link.click();
            })
            .catch(() => {
                toast.current?.show({
                    summary: "Erro",
                    severity: "error",
                    detail: "Não foi possível gerar a imagem do relatório.",
                });
            });
    };

    const handleDownloadPDF = () => {
        if (!printRef.current) return;

        html2canvas(printRef.current, { scale: 2, backgroundColor: "#ffffff" })
            .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");

                const pxToMm = (px) => (px * 25.4) / (96 * 2);
                const pdfWidth = pxToMm(canvas.width);
                const pdfHeight = pxToMm(canvas.height);

                const pdf = new jsPDF({
                    orientation: pdfHeight > pdfWidth ? "portrait" : "landscape",
                    unit: "mm",
                    format: [pdfWidth, pdfHeight],
                });

                pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                pdf.save(nomeArquivo("pdf"));
            })
            .catch(() => {
                toast.current?.show({
                    summary: "Erro",
                    severity: "error",
                    detail: "Não foi possível gerar o PDF do relatório.",
                });
            });
    };

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-3"
                title="Relatório de Qualidade Diário"
                subTitle={
                    <>
                        <Button
                            icon="pi pi-users"
                            label="Relatório de Qualidade por Operador"
                            className="p-button-outlined p-button-info p-mt-2 p-mr-1"
                            style={{ fontSize: '0.9rem' }}
                            onClick={() => navigate('/defeitos/relatorio-qualidade-operador')}
                        />
                        <Button
                            icon="pi pi-list"
                            label="Controle de Qualidade"
                            className="p-button-outlined p-button-info p-mt-2"
                            style={{ fontSize: '0.9rem' }}
                            onClick={() => navigate('/defeitos/controle-qualidade', { state: { date: date.toISOString() } })}
                        />
                    </>
                }
            >
                <Calendar
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    placeholder="Escolher outra data"
                    onChange={(e) => setDate(e.value)}
                    value={date}
                />
                <Button
                    icon="pi pi-search"
                    onClick={() => buscarRelatorio(date)}
                    loading={loading}
                />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10,
                        marginBottom: 12,
                        flexWrap: "wrap",
                    }}
                >
                    
                    <Button
                        icon="pi pi-image"
                        className="p-button"
                        title="Print do Relatório"
                        onClick={handleDownloadImage}
                        disabled={!data}
                    />
                    <Button
                        icon="pi pi-file-pdf"
                        className="p-button-danger"
                        title="PDF do Relatório"
                        onClick={handleDownloadPDF}
                        disabled={!data}
                    />
                </div>

                {loading && !data && (
                    <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                        <ProgressSpinner style={{ width: 40, height: 40 }} strokeWidth="4" />
                    </div>
                )}

                {data && (
                    <QualidadeDiario 
                        ref={printRef} 
                        data={data} 
                        foco={foco} 
                        onFocoChange={setFoco} 
                    />
                )}
            </Card>
        </div>
    );
}